import {
  AvatarNetwork,
  AvatarProps,
  FormAutocompleteField,
  FormAutocompleteFieldProps,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@razz-team/ui-web';
import { mapNetworkToFullName } from '@razz-team/utils';
import { useCallback } from 'react';

export function NetworkField<
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
>({
  ...props
}: Omit<FormAutocompleteFieldProps<string, Multiple, DisableClearable>, 'getOptionLabel'>) {
  const renderAvatar = useCallback((network: string, avatarProps: Partial<AvatarProps>) => {
    return network ? <AvatarNetwork network={network} {...avatarProps} /> : undefined;
  }, []);

  return (
    <FormAutocompleteField
      {...props}
      getOptionLabel={mapNetworkToFullName}
      renderAvatar={renderAvatar}
      renderOption={(props, network) => (
        <ListItem {...props} key={network} disablePadding>
          <ListItemAvatar>
            <AvatarNetwork network={network} size={32} />
          </ListItemAvatar>
          <ListItemText>{mapNetworkToFullName(network)}</ListItemText>
        </ListItem>
      )}
    />
  );
}
